import { render, staticRenderFns } from "./RedirectorForm.vue?vue&type=template&id=019152d0&scoped=true&"
import script from "./RedirectorForm.vue?vue&type=script&lang=js&"
export * from "./RedirectorForm.vue?vue&type=script&lang=js&"
import style0 from "./RedirectorForm.vue?vue&type=style&index=0&id=019152d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019152d0",
  null
  
)

export default component.exports